/**
 * SISTEMA DE DEBUG AVANÇADO PARA CHAT
 * Instrumentação completa para diagnosticar problemas de digitação
 */

// Flag global de debug - ativa apenas com DEBUG_CHAT=1 no .env
export const DEBUG_CHAT = import.meta.env.VITE_DEBUG_CHAT === '1';

// Flag global de debug do editor - ativa apenas com DEBUG_EDITOR=1 no .env
export const DEBUG_EDITOR = import.meta.env.VITE_DEBUG_EDITOR === '1';

/**
 * Logger estruturado para debug
 */
export const debugLog = {
  event: (info: any) => DEBUG_CHAT && console.log('[DBG EVT]', info),
  textarea: (info: any) => DEBUG_CHAT && console.log('[DBG TA]', info),
  textareaValue: (info: any) => DEBUG_CHAT && console.log('[DBG TA VAL]', info),
  render: (info: any) => DEBUG_CHAT && console.log('[DBG RENDER]', info),
  editor: (info: any) => DEBUG_CHAT && console.log('[DBG EDITOR]', info),
  serviceWorker: (info: any) => DEBUG_CHAT && console.log('[DBG SW]', info),
  window: (info: any) => DEBUG_CHAT && console.log('[DBG]', info),
  warn: (info: any) => DEBUG_CHAT && console.warn('[DBG WARN]', info),
  error: (info: any) => DEBUG_CHAT && console.error('[DBG ERROR]', info)
};

/**
 * Logger estruturado para debug do editor
 */
export const debugEditor = {
  format: (info: any) => DEBUG_EDITOR && console.info('[EDITOR:FORMAT]', { ...info, time: Date.now() }),
  selection: (info: any) => DEBUG_EDITOR && console.info('[EDITOR:SELECTION]', { ...info, time: Date.now() }),
  import: (info: any) => DEBUG_EDITOR && console.info('[EDITOR:IMPORT]', { ...info, time: Date.now() }),
  snapshot: (info: any) => DEBUG_EDITOR && console.info('[EDITOR:SNAPSHOT]', { ...info, time: Date.now() }),
  e2e: (info: any) => DEBUG_EDITOR && console.info('[EDITOR:E2E:RESULT]', { ...info, time: Date.now() })
};

/**
 * Helper para detectar se o elemento está dentro do chat
 */
export function isChatTarget(event: Event): boolean {
  const target = event.target as HTMLElement | null;
  if (!target) return false;
  
  return !!(
    target.closest?.('[data-prompt-input="true"]') ||
    target.closest?.('textarea[data-prompt-input]') ||
    target.closest?.('.prompt-input-container') ||
    target.closest?.('[data-caso-search]') ||
    target.id === 'chat-textarea-debug'
  );
}

/**
 * Helper para detectar se o elemento está dentro do editor
 */
export function isEditorTarget(event: Event): boolean {
  const target = event.target as HTMLElement | null;
  if (!target) return false;
  
  return !!(
    target.closest?.('[contenteditable="true"]') ||
    target.closest?.('.document-editor')
  );
}

/**
 * Detecta se o chat está ativo (via atributo global)
 */
export function isPromptActive(): boolean {
  return document.documentElement.getAttribute('data-prompt-active') === 'true';
}